import { render, staticRenderFns } from "./AdminCreateContact.vue?vue&type=template&id=2298e662&scoped=true&"
import script from "./AdminCreateContact.vue?vue&type=script&lang=js&"
export * from "./AdminCreateContact.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreateContact.vue?vue&type=style&index=0&id=2298e662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2298e662",
  null
  
)

export default component.exports